/* global google */

import { srcCorregimientos, center } from './../../constants/services/map'

var map;
var polyCroquis
var pregs = [];


const initMap = () => {
  map = new google.maps.Map(document.getElementById('map'), {
    center,
    zoom: 9,
    disableDefaultUI: true,
    styles: styleRoad
  });

  HttpServiceCroquis(srcCorregimientos);

  let divAdmin = document.createElement('div');
  divAdmin.classList.add('globo-mapa');
  divAdmin.classList.add('top-left');
  let labelTitle = document.createElement('label')
  labelTitle.classList.add('color-white')
  labelTitle.innerText = 'Comuna: '
  divAdmin.appendChild(labelTitle)
  let spanMun = document.createElement('span')
  spanMun.classList.add('color-white')
  spanMun.id = 'mpio-text'
  divAdmin.appendChild(spanMun)
  let divSelecteds = document.createElement('div')
  divSelecteds.id = 'legends-selected'
  divAdmin.appendChild(divSelecteds)
  let paraf = document.createElement('p');
  paraf.id = 'mouse-over';
  paraf.classList.add('popup-bundle-title');
  divAdmin.appendChild(paraf);


  let divRseult = document.createElement('div');
  divRseult.classList.add('globo-mapa');
  divRseult.classList.add('top-right');
  divRseult.classList.add('size-close');
  divRseult.classList.add('perception-style');

  let icon = document.createElement('i');
  icon.classList.add('fas')
  icon.classList.add('fa-plus')
  icon.classList.add('open-close-legend')
  icon.classList.add('perception-icon-style')
  icon.setAttribute('title', 'Abrir')
  let legend = document.createElement('div')
  legend.setAttribute('id', 'legend-map')
  legend.classList.add('display-none')
  legend.classList.add('legend-map-container')
  icon.addEventListener('click', () => {
    if (divRseult.classList.contains('size-open')) {
      divRseult.classList.remove('size-open')
      icon.classList.remove('rotate-x')
      legend.classList.add('display-none')
    } else {
      divRseult.classList.add('size-open')
      icon.classList.add('rotate-x')
      setTimeout(() => {
        legend.classList.remove('display-none')
      }, 700)
    }
  });
  let divIcon = document.createElement('p')
  divIcon.classList.add('p-x')
  divIcon.appendChild(icon)
  divRseult.appendChild(divIcon)
  divRseult.appendChild(legend)

  createBotonMap({
    classIcon: ['fas', 'fa-monument', 'boton-logo-icon'],
    classCompare: 'fa-monument',
    classAdd: 'fa-map-signs',
    func1: () => map.setOptions({ styles: [] }),
    func2: () => map.setOptions({ styles: styleRoad }),
  })

  createBotonMap({
    classDiv: ['boton-mapa', 'bottom-left3', 'boton-circular'],
    classIcon: ['fas', 'fa-thermometer-half', 'boton-logo-icon'],
    classCompare: 'fa-thermometer-half',
    classAdd: 'fa-map-marker-alt',
    idIcon: 'heat-icon',
    func1: () => {
      pregs.filter(f => f.active).forEach(item => {
        item.heat.setMap(map)
        item.markers.forEach(m => m.setVisible(false))
      })
      document.getElementById('lock-heat-boton').classList.remove('display-none')
    },
    func2: () => {
      pregs.filter(f => f.active).forEach(item => {
        item.heat.setMap(null)
        item.markers.forEach(m => m.setVisible(true))
      })
      document.getElementById('lock-heat-boton').classList.add('display-none')
    },
  })

  createBotonMap({
    classDiv: ['boton-mapa', 'bottom-left4', 'boton-circular', 'display-none'],
    classIcon: ['fas', 'fa-lock-open', 'boton-logo-icon'],
    classCompare: 'fa-lock-open',
    classAdd: 'fa-lock',
    idDiv: 'lock-heat-boton',
    func1: () => {
      const zoom = map.getZoom()
      map.addListener("zoom_changed", () => {
        let radius = 20;
        switch (map.getZoom() - zoom) {
          case 8: radius = 3500; break;
          case 7: radius = 2000; break;
          case 6: radius = 1100; break;
          case 5: radius = 640; break;
          case 4: radius = 320; break;
          case 3: radius = 160; break;
          case 2: radius = 80; break;
          case 1: radius = 40; break;
          case 0: radius = 20; break;
          case -1: radius = 10; break;
          case -2: radius = 5; break;
          case -3: radius = 3; break;
          case -4: radius = 1; break;
          default: break;
        }
        pregs.forEach(p => {
          if (p.active) p.heat.set("radius", radius)
        })
      });
    },
    func2: () => {
      google.maps.event.clearListeners(map, "zoom_changed");
      pregs.forEach(p => {
        if (p.active) p.heat.set("radius", 20)
      })
    },
  })

  

  createBotonMap({
    classDiv: ['boton-mapa', 'bottom-left2', 'boton-circular'],
    classIcon: ['fas', 'fa-satellite', 'boton-logo-icon'],
    classCompare: 'fa-satellite',
    classAdd: 'fa-map',
    func1: () => map.setMapTypeId('hybrid'),
    func2: () => map.setMapTypeId('roadmap'),
  })

  document.getElementById('map').appendChild(divAdmin);
  document.getElementById('map').appendChild(divRseult);
  let divContent = document.createElement('div');
  divContent.id = 'content';
  document.getElementById('map').appendChild(divContent);
}

const createBotonMap = (opts) => {
  if (!opts) opts = {}
  const ops = {
    classDiv: opts.classDiv ? opts.classDiv : ['boton-mapa', 'bottom-left', 'boton-circular'],
    classIcon: opts.classIcon ? opts.classIcon : ['fas', 'fa-smile', 'boton-logo-icon'],
    classCompare: opts.classCompare ? opts.classCompare : 'fa-smile',
    classAdd: opts.classAdd ? opts.classAdd : 'fa-smile-wink',
    idDiv: opts.idDiv ? opts.idDiv : '',
    idIcon: opts.idIcon ? opts.idIcon : '',
    func1: opts.func1 ? opts.func1 : () => { },
    func2: opts.func2 ? opts.func2 : () => { },
  }
  let div = document.createElement('div');
  ops.classDiv.forEach(c => div.classList.add(c))
  div.id = ops.idDiv
  let icon = document.createElement('i')
  ops.classIcon.forEach(c => icon.classList.add(c))
  icon.id = ops.idIcon
  div.addEventListener("click", function () {
    if (icon.classList.contains(ops.classCompare)) {
      icon.classList.remove(ops.classCompare)
      icon.classList.add(ops.classAdd)
      ops.func1()
    } else {
      icon.classList.add(ops.classCompare)
      icon.classList.remove(ops.classAdd)
      ops.func2()
    }
  });
  div.appendChild(icon)
  document.getElementById('map').appendChild(div);
}

const createLegend = () => {
  pregs.forEach(v => createLegendItem(v))
}

const createLegendItem = (item) => {
  const legend = document.getElementById('legend-map')
  const legendText = document.createElement('div')
  legendText.classList.add('display-none')
  legendText.setAttribute('style', 'color:white; margin:5px')
  legendText.innerText = item.pregunta
  const legendsSelected = document.getElementById('legends-selected')
  legendsSelected.appendChild(legendText)
  const container = document.createElement('div')
  container.classList.add('legends-container-map')
  const tagsContainer = document.createElement('div')
  tagsContainer.classList.add('tags-container')
  const icon = document.createElement('i');
  icon.classList.add('fas')
  icon.classList.add('fa-eye-slash')
  icon.classList.add('open-close-legend')
  icon.setAttribute('style', 'color:gray; margin:auto 1px')
  const eyeSpan = document.createElement('span')
  eyeSpan.classList.add('width-22px')
  eyeSpan.appendChild(icon)
  eyeSpan.addEventListener('click', () => {
    const heatState = document.getElementById('heat-icon').classList.contains('fa-map-marker-alt')
    if (item.active) {
      icon.classList.remove('fa-eye')
      icon.classList.add('fa-eye-slash')
      if (heatState) item.heat.setMap(null)
      else item.markers.forEach(m => m.setVisible(false))
      legendText.classList.add('display-none')
    } else {
      icon.classList.add('fa-eye')
      icon.classList.remove('fa-eye-slash')
      if (heatState) item.heat.setMap(map)
      else item.markers.forEach(m => m.setVisible(true))
      legendText.classList.remove('display-none')
    }
    item.active = !item.active
  });
  const pinSpan = document.createElement('span')
  pinSpan.classList.add('horizontal-margin-4px')
  pinSpan.innerHTML = `<img src="${item.pin}" alt="pin">`
  const textContainer = document.createElement('div')
  textContainer.innerText = item.pregunta
  textContainer.classList.add('primary-color')
  textContainer.classList.add('tags-container')
  tagsContainer.appendChild(eyeSpan)
  tagsContainer.appendChild(pinSpan)
  container.appendChild(tagsContainer)
  container.appendChild(textContainer)
  legend.appendChild(container)
}

export const startMap = (opts) => {
  setTimeout(() => {
    initMap(opts);
  }, 700);
}

export const setData = (data, result) => {
  const exist = document.getElementById('legends-selected');
  if (!exist) setTimeout(() => setData(data, result), 100);
  else setDataOnDom(data, result);
}

const setDataOnDom = (data, result) => {
  try {
    pregs = data.map(item => {
      const coords = result.filter(f => (f[item.lat] && f[item.lng]))
        .map(coor => new google.maps.LatLng({ lat: coor[item.lat], lng: coor[item.lng] }))
      const heat = new google.maps.visualization.HeatmapLayer({ data: coords })
      heat.set('maxIntensity', coords.length * 0.01);
      heat.set('radius', 20);
      const icon = getIconPath(item.numero)
      return {
        pregunta: item.pregunta,
        pin: icon,
        active: false,
        heat,
        markers: coords.map(coor => {
          return new google.maps.Marker({
            position: coor,
            map,
            icon,
            visible: false
          })
        }),
      }
    });
    createLegend(pregs)
  } catch (error) { console.log(error) }
}

function getIconPath(key) {
  const url_ini = 'https://villavo-demo-rec.s3-us-west-1.amazonaws.com/map_icons/Points10px/'
  switch (key) {
    case '21.1': return url_ini + "BluePoint.png"
    case '21.2': return url_ini + "YellowPoint.png"
    case '22.1': return url_ini + "BlueVioletPoint.png"
    case '22.2': return url_ini + "GrayPoint.png"
    case '22.3': return url_ini + "GreenBluePoint.png"
    case '22.4': return url_ini + "GreenPoint.png"
    case '22.5': return url_ini + "OrangePoint.png"
    case '22.6': return url_ini + "PinkPoint.png"
    case '22.7': return url_ini + "PurplePoint.png"
    case '22.8': return url_ini + "RedOrangePoint.png"
    case '22.9': return url_ini + "RedPoint.png"
    case '22.10': return url_ini + "SkyBlue.png"
    case '22.11': return url_ini + "VioletPoint.png"
    case '22.12': return url_ini + "YellowGreenPoint.png"
    case '22.13': return url_ini + "YellowOrangePoint.png"
    default: return url_ini + "YellowPoint.png"
  }
}

function HttpServiceCroquis(src) {
  var xhttpIcon = new XMLHttpRequest();
  xhttpIcon.onreadystatechange = function () {
    if (this.readyState === 4) {
      if (this.status === 200) {
        // DeletePolysInMap(capaActual);
        var xmlString = this.response;
        var parser = new DOMParser();
        var comunas = parser.parseFromString(xmlString, "text/xml")
        var dataPolys = CreateDataForPolygon(comunas, false)
        polyCroquis = CreatePolygonLayer(dataPolys, { zIndex: 1, color: 'rgb(0,183,255)', fillOpacity: 0 });    //amarillo
        SetPolysInMap(polyCroquis);
        setTimeout(() => {
          fitAllMap()
        }, 1000)
      }
      else {
        console.error(this.responseText);
      }
    }
  };
  xhttpIcon.open("GET", src, true);
  xhttpIcon.send();
}

function fitAllMap() {
  let bounds = new google.maps.LatLngBounds();
  for (let i = 0; i < polyCroquis.length; i++) {
    if (polyCroquis[i].desc.NOMBRE_VER.includes('COMUNA')) {
      bounds = getBounds(polyCroquis[i], bounds)
    }
  }
  map.fitBounds(bounds);
}

function CreateDataForPolygon(doc, isCroquis = true) {
  let polygons = [];
  var places = doc.getElementsByTagName('Placemark');
  for (let i = 0; i < places.length; i++) {
    var coords = places[i].getElementsByTagName('coordinates');
    for (let j = 0; j < coords.length; j++) {
      polygons.push({
        polygon: GetCordsFromPlacemark(coords[j]),
        description: isCroquis ? 'shape' : GetDescFromPlacemark(places[i])
      })
    }
  }
  return polygons;
}

function getBounds(poly, bounds) {
  var latLngs = poly.getPath()
  for (var i = 0; i < latLngs.length; i++) {
    bounds.extend(latLngs.getAt(i));
  }
  return bounds
}

function GetDescFromPlacemark(place) {
  var desc = place.getElementsByTagName('SchemaData')[0].getElementsByTagName('SimpleData');
  var resp = {};
  for (let i = 0; i < desc.length; i++) {
    resp = {
      ...resp,
      [desc[i].getAttribute('name')]: desc[i].innerHTML
    }
  }
  return resp;
}
function GetCordsFromPlacemark(coords) {
  var coordsVec = coords.innerHTML.split(" ");
  var resp = [];
  for (let i = 0; i < coordsVec.length; i++) {
    let vec = coordsVec[i].split(',');
    if (!isNaN(Number(vec[1])))
      resp.push({ lng: Number(vec[0]), lat: Number(vec[1]) });
  }
  // let tales = CreatePolygonMap(resp, color, fillOpacity, description, zIndex)
  return resp
}

function CreatePolygonLayer(data, options = { zIndex: 1, color: '#fff', fillOpacity: '0' }) {
  var polygonsLayer = data.filter(item => {
    return true
  }).map(item => {
    return CreatePolygonMap(item.polygon, item.description, options)
  })
  return polygonsLayer
}

function CreatePolygonMap(coords, description, options) {
  var poly = new google.maps.Polygon({
    paths: coords,
    strokeColor: options.color,
    strokeOpacity: 1,
    strokeWeight: 1,
    fillColor: options.color,
    fillOpacity: options.fillOpacity,
    zIndex: options.zIndex,
    desc: description
  });
  google.maps.event.addListener(poly, 'mouseover', function (event) {
    document.getElementById('mpio-text').innerText = description.NOMBRE_VER
    poly.setOptions({ strokeWeight: 3 })
    if (description === 'shape')
      return

  });
  google.maps.event.addListener(poly, 'mouseout', function (event) {
    document.getElementById('mpio-text').innerText = ''
    poly.setOptions({ strokeWeight: 1 })

    if (description === 'shape')
      return
  })
  return poly;
}

function SetPolysInMap(polygon) {
  for (let i = 0; i < polygon.length; i++) {
    polygon[i].setMap(map)
  }
}


var styleRoad = [
  {
    "featureType": "administrative",
    "elementType": "geometry",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "poi",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "transit",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  }
]
